import { isEmpty, prune } from '../../utils';

import { ResourceObject, ResourceMetric, PerformanceData } from './types';

const getNetworkMetrics = () => {
  const connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection ||
    navigator.msConnection ||
    navigator.oConnection;
  return {
    downlink: connection?.downlink,
    downlinkMax: connection?.downlinkMax,
    effectiveType: connection?.effectiveType,
    rtt: connection?.rtt,
    saveData: connection?.saveData,
    type: connection?.type,
  };
};

class MetricCalc {
  // options: Options;
  appName: string;
  metric: ResourceMetric;
  scope: ResourceObject;
  performance: ResourceObject;

  constructor(appName: string) {
    // this.options = options;
    this.appName = appName;
    this.metric = {};
    this.scope = {};
    this.performance = window.performance;
    return this;
  }

  init = (): MetricCalc => {
    this.metric = {
      to: window.location.pathname,
      startTime: Date.now(),
      is_page_load: true,
    };
    return this;
  };

  getPerformanceData = (): PerformanceData | undefined => {
    if (!isEmpty(this.metric)) {
      const timeTaken = Date.now() - this.metric.startTime;
      const performanceData = {
        ...this.scope,
        isInBackground: document.hidden,
        page_url: this.metric.to,
        perceived_page_load_time: timeTaken,
        is_page_load: this.metric.is_page_load || false,
        network: getNetworkMetrics(),
      };
      this.resetMetric();
      return performanceData;
    }
  };

  resetMetric = (): void => {
    this.metric = {};
  };

  appTransitionStart = (
    toLocation: { pathname?: string } = {},
    fromLocation: { pathname?: string } = {}
  ) => {
    this.resetMetric();
    this.metric = prune({
      to: toLocation.pathname,
      from: fromLocation.pathname,
      startTime: Date.now(),
    });
  };

  addDataToScope = (data: ResourceObject): void => {
    this.scope = {
      ...this.scope,
      ...data,
    };
  };
}

export default MetricCalc;
